import { Controller } from "@hotwired/stimulus"

// Hover of a sparkline (shared/_sparkline): a vertical line and a dot at the nearest point, its title and value above.
// points: [{ title, value, x, y }], x/y in percents of the sparkline (null y: no value there)
export default class extends Controller {
  static targets = ['cursor', 'dot', 'tooltip', 'title', 'value']
  static values  = { points: Array }

  move(event) {
    const points = this.pointsValue
    if (!points.length) return

    const rect  = this.element.getBoundingClientRect()
    const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1)
    const point = points[Math.round(ratio * (points.length - 1))]
    if (point.x == null) return this.leave()

    this.cursorTarget.style.left = `${point.x}%`
    this.dotTarget.style.left    = `${point.x}%`
    this.dotTarget.style.top     = `${point.y}%`
    this.titleTarget.textContent = point.title
    this.valueTarget.textContent = point.value

    // Above the sparkline, next to the line on the side with more room
    const right = point.x <= 50
    this.tooltipTarget.style.left  = right ? `calc(${point.x}% + 10px)` : ''
    this.tooltipTarget.style.right = right ? '' : `calc(${100 - point.x}% + 10px)`

    this.cursorTarget.hidden = this.dotTarget.hidden = this.tooltipTarget.hidden = false
  }

  leave() {
    this.cursorTarget.hidden = this.dotTarget.hidden = this.tooltipTarget.hidden = true
  }
}
